import React from "react";
import WavyDivider from "./WavyDivider";
import { Activity, ShieldCheck, Leaf } from "lucide-react";

const QVCT = () => {
  return (
    <section id="qvct" className="section qvct">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Shiatsu en Entreprise</h2>
        <h3 className="section-subtitle">
          La Santé au travail et la Prévention constituent des préoccupations majeures pour les entreprises, dans le cadre de la politique RSE, et des engagements de la QVCT. Le Shiatsu s’intègre parfaitement dans cette démarche en apportant un « boost » physique et psychologique aux collaborateurs.
        </h3>
      </div>

      <div className="qvct-grid">
        <div className="qvct-card">
          <span className="qvct-icon"><Activity size={22} strokeWidth={1.6} /></span>
          <h4>Réduction des Troubles Musculo-Squelettiques</h4>
          <p>Outil reconnu pour prévenir les troubles musculo-squelettiques liés aux postures et au rythme de travail.</p>
        </div>
        <div className="qvct-card">
          <span className="qvct-icon"><ShieldCheck size={22} strokeWidth={1.6} /></span>
          <h4>Prévention des risques psychosociaux</h4>
          <p>Agit sur les risques psychosociaux (stress, surcharge mentale) susceptibles d’impacter les performances.</p>
        </div>
        <div className="qvct-card">
          <span className="qvct-icon"><Leaf size={22} strokeWidth={1.6} /></span>
          <h4>Bien-être &amp; engagement</h4>
          <p>Favorise la détente, la concentration et renforce le sentiment de reconnaissance au sein des équipes.</p>
        </div>
      </div>

      <div className="qvct-cta">
        <a href="#contact" className="btn btn-primary">DEMANDER UN DEVIS</a>
      </div>
    </section>
  );
};

export default QVCT;
